import { PageId } from 'constants/pages'

export const enum PageIdWoofzEaster75 {
  SUBSCRIPTIONS_EASTER_75 = PageId.SUBSCRIPTIONS_EASTER_75,
  CHAT_UPSELL_EASTER_75 = PageId.CHAT_UPSELL_EASTER_75,
  UPSELL_EASTER_75 = PageId.UPSELL_EASTER_75,
  DOWNLOAD_EASTER_75 = PageId.DOWNLOAD_EASTER_75,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
